import React from 'react';

import ForgotPasswordForm from './ForgotPasswordForm';

const ForgotPassword = ({ locales }) => {
  return (
    <>
      <ForgotPasswordForm locales={locales} />
    </>
  );
};

export default ForgotPassword;
